
function CustomerDataExport() {
    /// <summary>
    /// This object provides js functions for the Widget.Exports.Cusotmer.DataExport.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 3.10.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.10.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bsaid = -1;
}

CustomerDataExport.prototype = new vcTemplate();

CustomerDataExport.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#ddlCustomer").val(3);
        me.showInfo("", "", false);
        me.visual.find("#btnExport").off("click").on("click",
            function() {
                alert(me.visual.find("#ddlCustomer").val());
            }).button();
        me.visual.find("#armin").html(me.resources.addBill);
    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



